import { useState, useEffect } from "react";
import { DeleteOutlined, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Button, Divider, List, Typography, ListItemButton, CircularProgress, LinearProgress } from "@mui/material";
import { ccyFormat } from "../../../helpers/helper";
import CompraData from "./CompraData";
import Banner from "../../Banner";
import { STATUS_SALE } from "../../../helpers/enums";
import RadioGroup from '../../../components/RadioGroup';

const StockMovement = ({ loading, readonly = false, compras = [], isHistorial = false, viewMoney = false, customers = [], onReturn }) => {
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedCompras, setSelectedCompras] = useState(compras);
  const cus = [...(new Set(compras?.map(item => item.article?.customer_id)))]
  const customersInSales = customers?.filter(customer => cus.includes(customer._id)).concat({ name: 'TODOS', _id: 'all' })

  const totalSums = selectedCompras ? selectedCompras.reduce(
    (sums, item) => {
      const amount = item.type === "decrement" ? item.prices.sale_price * item.quantity * -1 : item.prices.list_price * item.quantity;

      if (item.type === "increment") {
        sums.increment += amount;
        sums.quantityIncrement += item.quantity
      } else if (item.type === "decrement" && (!item.sale || (item.sale && item.sale.status === STATUS_SALE.FINISHED))) {
        sums.decrement += amount;
        sums.quantityDecrement += item.quantity
      }

      return sums;
    },
    { increment: 0, decrement: 0, quantityIncrement: 0, quantityDecrement: 0 } // Valor inicial para el acumulador
  ) : { increment: 0, decrement: 0, quantityIncrement: 0, quantityDecrement: 0 };

  useEffect(() => {
    //var groupSale = groupSales(salesData)
    if (['all', ''].includes(selectedCustomer)) {
      setSelectedCompras(compras)
    } else {
      var comprasFilter = compras.filter(c => c.article?.customer_id === selectedCustomer)
      setSelectedCompras(comprasFilter)
      console.log(comprasFilter)
    }
  }, [selectedCustomer])

  const handleReturn = (compra) => {
    onReturn && onReturn(compra)
  }

  return loading ? <LinearProgress /> : <><List sx={{ overflowY: 'auto', width: '100%', paddingY: 2, paddingX: 0, background: 'transparent' }} >
    {isHistorial ? <Box>
      <Typography display='flex' flexDirection='column' justifyContent='flex-start' variant='inherit' width='100%' alignItems='flex-start' paddingBottom={2}>
        <Typography variant='h5'><span>{`${(compras ? compras[0]?.article.name : '')}`}</span></Typography>
        <Typography variant='caption'><span>{`${(compras ? compras[0]?.article.description : '')}`}</span></Typography>
      </Typography>
      <Banner images={compras ? compras[0]?.article.images : null} />
    </Box> : <Box display='flex' flexDirection='column'>
      <RadioGroup options={customersInSales} onValueChange={value => { console.log(value); setSelectedCustomer(value) }} />
    </Box>}
    {selectedCompras?.map(compra => {
      return (<>
        <CompraData compra={compra} loading={loading} readonly={readonly} isHistorial={isHistorial} onReturn={handleReturn}/>
        <Divider />
      </>)
    })}
  </List>
    <Box display='flex' flexDirection='row' justifyContent='space-between'>
      <Typography variant="subtitle2" aria-label="delete">
        {`${totalSums.quantityIncrement} - COMPRAS `}
      </Typography>
      <Typography variant="subtitle2" aria-label="delete">
        {totalSums.increment ? `$ ${ccyFormat(totalSums.increment)}` : ccyFormat(0)}
      </Typography>
    </Box>
    {isHistorial && <Box display='flex' flexDirection='row' justifyContent='space-between'>
      <Typography variant="subtitle2" aria-label="delete">
        {`${-1 * totalSums.quantityDecrement} - VENTAS `}
      </Typography>
      <Typography variant="subtitle2" aria-label="delete">
        {totalSums.decrement ? `$ ${ccyFormat(totalSums.decrement)}` : ccyFormat(0)}
      </Typography>
    </Box>}
  </>
}


export default StockMovement;